import React, { useEffect, useState, useCallback } from "react";
import {
    useLoadCandidateAppsQuery,
    useLoadAppRuningTasksQuery
} from "../../store/candidateApiSlice";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { getFieldData, getFormatedNumber } from "../../../Services/appService";
import { getCurrentUser } from "../../store/auth";
import { getAppTasks, getCandidateApps, loadAppRuningTasks, loadCandidateApps } from "../../store/candidate";
import { useDispatch, useSelector } from "react-redux";
import TimerPopup from "../../../Components/TimerPopup";
import AppMessages from "../../../Components/AppMessages";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import { OverlayTrigger, Popover } from "react-bootstrap";

const ONBOARDING_STATUS_STYLES = {
    card: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        borderRadius: "0px",
        border: "1px solid #e5e5e5",
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
        overflow: "hidden"
    },
    cardHeader: {
        padding: "14px 20px",
        borderBottom: "1px solid #e5e5e5",
        background: "#ffffff"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    headerCopy: {
        minWidth: "240px",
        flex: "1 1 420px"
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    title: {
        fontSize: "16px",
        fontWeight: 600,
        color: "#000000",
        lineHeight: 1.25,
        margin: 0
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px"
    },
    titleIcon: {
        width: "32px",
        height: "32px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#000000",
        fontSize: "14px",
        border: "1px solid #e5e5e5",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        minWidth: 0
    },
    subtitle: {
        fontSize: "13px",
        lineHeight: 1.5,
        color: "#666666",
        margin: 0
    },
    cardBody: {
        padding: "0"
    },
    utilityRow: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        marginBottom: "14px"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none"
    },
    tableWrap: {
        overflowX: "auto",
        backgroundColor: "#ffffff"
    },
    table: {
        width: "100%",
        marginBottom: 0,
        borderCollapse: "separate",
        borderSpacing: 0,
        fontSize: "13px",
        color: "#333333"
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#666666",
        background: "#f5f5f5",
        borderBottom: "1px solid #e5e5e5",
        padding: "14px 16px"
    },
    rowCell: {
        verticalAlign: "top",
        padding: "16px 18px",
        borderTop: "1px solid #e5e5e5",
        background: "#ffffff",
        fontWeight: 600
    },
    idValue: {
        fontSize: "13.5px",
        fontWeight: 600,
        color: "#000000",
        display: "flex",
        alignItems: "center",
        gap: "6px"
    },
    idIcon: {
        color: "#94a3b8",
        fontSize: "11px"
    },
    dateContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "2px"
    },
    datePrimary: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#000000",
        display: "flex",
        alignItems: "center",
        gap: "6px"
    },
    dateSecondary: {
        fontSize: "11.5px",
        color: "#666666",
        fontWeight: 600
    },
    personCard: {
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        maxWidth: "250px"
    },
    personAvatar: {
        width: "36px",
        height: "36px",
        borderRadius: "0px",
        background: "#f1f5f9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#0f172a",
        fontSize: "13px",
        fontWeight: 600,
        flexShrink: 0
    },
    personInfo: {
        display: "flex",
        flexDirection: "column",
        gap: "3px",
        minWidth: 0
    },
    personName: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#0f172a",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    personMeta: {
        fontSize: "12.5px",
        lineHeight: 1.45,
        color: "#475569",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontWeight: 500
    },
    actionStack: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        alignItems: "flex-start"
    },
    viewAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none",
        whiteSpace: "nowrap"
    },
    editAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none",
        whiteSpace: "nowrap"
    },
    statusPillBase: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 14px",
        borderRadius: "0px",
        fontSize: "12.5px",
        fontWeight: 600,
        border: "1px solid transparent",
        whiteSpace: "nowrap"
    },
    unreadBadge: {
        position: "absolute",
        top: "-5px",
        right: "-5px",
        minWidth: "18px",
        height: "18px",
        borderRadius: "0px",
        background: "#ef4444",
        color: "#ffffff",
        fontSize: "10px",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid #ffffff",
        padding: "0 4px"
    },
    noteButton: {
        border: "1px solid #e5e5e5",
        background: "#f5f5f5",
        color: "#2563eb",
        padding: "7px 14px",
        fontSize: "12.5px",
        fontWeight: 600,
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px"
    }
};

export default function OnboardingStatus() {

    const usrType = localStorage.getItem("userType");
    const [entityType, setEntityType] = useState("");
    const [appTasklist, setAppTasklist] = useState([]);
    const [appSubmitStatus, setAppSubmitStatus] = useState(false);
    const [timerShowHide, setTimerShowHide] = useState(false);
    const [msgShowHide, setMsgShowHide] = useState(false);
    const [wfId, setWfId] = useState(0);
    const [currentApp, setCurrentApp] = useState("");

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const navigate = useNavigate();

    let usrId = currentUser?.id;
    if (currentUser?.linkUser) usrId = currentUser.linkUser;

    const {
        data: candidateAppsSelector = [],
        isLoading: isAppsLoading,
        isFetching: isAppsFetching,
        refetch: refetchCandidateApps
    } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });

    const {
        data: appTasksSelector = [],
        isLoading: isTasksLoading,
        isFetching: isTasksFetching,
        refetch: refetchAppTasks
    } = useLoadAppRuningTasksQuery(
        { wfId, userId: usrId },
        { skip: !wfId || !usrId }
    );

    const isInitialLoading = isAppsLoading || (!wfId && candidateAppsSelector.length === 0) || isTasksLoading;
    const isDataFetching = isAppsFetching || isTasksFetching;
    const isDataLoading = isInitialLoading || (isDataFetching && appTasklist.length === 0);

    const route = [
        { name: "Task Management", url: "" },
        { name: "Onboarding", url: "" },
    ];
    const route1 = [
        { name: "Contract Management", url: "" },
        { name: "Onboarding", url: "" },
    ];

    let appType = "Onboarding";
    if (usrType === "candidate")
        appType = "Onboarding";

    let count = entityType !== "C2C Basis" ? "6" : "5";

    if (usrType !== "candidate")
        count = "5";


    useEffect(() => {
        dispatch(setCurrentPageTitle(`STEP-${count} : ${appType}`));
        dispatch(setCurrentRoute(usrType === "candidate" ? route : route1));
    }, [dispatch, count, appType, usrType, route, route1]);

    useEffect(() => {
        if (candidateAppsSelector.length > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                setWfId(wf.oldWorkflowId);
            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0
                && (x.wfPhase === "Review" || x.wfPhase === "Approved" || x.wfPhase === "Rejected"));
            let firstAppTasks = [];
            if (filterTasks.length > 0) {
                firstAppTasks = [filterTasks[filterTasks.length - 1]];
                setAppTasklist(firstAppTasks);
                setAppSubmitStatus(filterTasks[0].appSubmit);
                const entType = getFieldData(
                    firstAppTasks[0].stateData,
                    "candidateonboardingform",
                    "CandidateEntity"
                );
                setEntityType(entType);
            }
        }
    }, [appTasksSelector]);

    const handleViewAppSummary = (item, type) => {
        navigate("/ApplicationSummary", { state: { task: item, viewType: type } });
    }

    const handleRefresh = () => {
        if (refetchCandidateApps) refetchCandidateApps();
        if (refetchAppTasks) refetchAppTasks();
        let usrId = currentUser?.id;
        if (currentUser?.linkUser) usrId = currentUser.linkUser;
        if (usrId > 0) dispatch(loadCandidateApps(usrId, { subscribe: false, forceRefetch: true }));
        if (wfId > 0 && usrId > 0) dispatch(loadAppRuningTasks(wfId, usrId, { subscribe: false, forceRefetch: true }));
    };

    const handleCurrentTask = () => {
        // const { data: workflowTask } = await http.get(
        //     config.GetWorkflowTask + wiid
        //   );
        //   if (workflowTask.formId > 0) {
        //     if (workflowTask.formType === "CF") {
        //       this.props.history.push({
        //         pathname: "/" + workflowTask.formName,
        //         state: { workflowTask },
        //       });
        //     } else {
        //       this.props.history.push({
        //         pathname: "/DynamicForm",
        //         state: { workflowTask },
        //       });
        //     }
        //   }
    }

    const handleTimerModalShowHide = () => {
        setTimerShowHide(!timerShowHide);
    };

    const handleMsgShowHide = (app) => {
        setCurrentApp(app);
        setMsgShowHide(!msgShowHide);
    };

    const formatCustomDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return isNaN(date.getTime()) ? "-" : date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    };

    const getPopover = (notes) => {
        if (!notes) return null;
        return (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="top"
                overlay={
                    <Popover id="popover-notes" style={{ ...ONBOARDING_STATUS_STYLES.card, maxWidth: "300px", padding: "10px", fontSize: "12px" }}>
                        <strong>Notification Notes:</strong>
                        <div style={{ marginTop: "4px" }}>{notes}</div>
                    </Popover>
                }
            >
                <button
                    type="button"
                    className="btn btn-sm p-0"
                    style={{ ...ONBOARDING_STATUS_STYLES.noteButton, cursor: "pointer", border: "none", background: "transparent" }}
                >
                    <i className="fa fa-info-circle mr-1" style={{ color: "#2563eb" }} aria-hidden="true"></i>
                    Notes
                </button>
            </OverlayTrigger>
        );
    };

    const renderReviewerDetails = (name, email, contact, time) => {
        if (!name && !email && !contact) return <span style={{ color: "#94a3b8", fontWeight: 500 }}>-</span>;

        return (
            <div style={ONBOARDING_STATUS_STYLES.personCard}>
                <div style={ONBOARDING_STATUS_STYLES.personAvatar}>
                    <i className="fa fa-user" aria-hidden="true"></i>
                </div>
                <div style={ONBOARDING_STATUS_STYLES.personInfo}>
                    {name && (
                        <div style={ONBOARDING_STATUS_STYLES.personName}>
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {name}
                            </span>
                        </div>
                    )}
                    {email && (
                        <div style={ONBOARDING_STATUS_STYLES.personMeta}>
                            {email}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const getStatusPillStyle = (wfPhase) => {
        if (wfPhase === "Approved") {
            return {
                ...ONBOARDING_STATUS_STYLES.statusPillBase,
                color: "#0f172a",
                backgroundColor: "#2dce898c",
                borderColor: "#2dce89"
            };
        }

        if (wfPhase === "Rejected") {
            return {
                ...ONBOARDING_STATUS_STYLES.statusPillBase,
                color: "#b91c1c",
                backgroundColor: "#fef2f2",
                borderColor: "rgba(254, 202, 202, 1)"
            };
        }

        return {
            ...ONBOARDING_STATUS_STYLES.statusPillBase,
            color: "#0f172a",
            backgroundColor: "#ffd600",
            borderColor: "#ffd600"
        };
    };


    return <React.Fragment>

        <div className="mt-2 form-group">
            <style>{`
                .onboarding-status-table tbody tr:hover td {
                    background-color: #f8fbff !important;
                }

                @media (max-width: 991.98px) {
                    .onboarding-status-table {
                        min-width: 1100px;
                    }
                }

                .onb-link-btn,
                .onb-link-btn:hover,
                .onb-link-btn:focus,
                .onb-link-btn.focus,
                .onb-link-btn:active,
                .onb-link-btn:not(:disabled):not(.disabled):active {
                  background: none !important;
                  background-color: transparent !important;
                  border: none !important;
                  box-shadow: none !important;
                  outline: none !important;
                  padding: 0 !important;
                }
                .onb-link-btn:hover {
                  text-decoration: underline !important;
                  color: #1d4ed8 !important;
                }
            `}</style>
            <div className="card shadow-none border-1" style={ONBOARDING_STATUS_STYLES.card}>
                <div className="card-header border-1" style={ONBOARDING_STATUS_STYLES.cardHeader}>
                    <div style={ONBOARDING_STATUS_STYLES.headerRow}>
                        <div style={ONBOARDING_STATUS_STYLES.headerCopy}>
                            <div style={ONBOARDING_STATUS_STYLES.titleRow}>
                                <span style={ONBOARDING_STATUS_STYLES.titleIcon}>
                                    <i className="fa fa-clipboard" aria-hidden="true"></i>
                                </span>
                                <div style={ONBOARDING_STATUS_STYLES.titleText}>
                                    <h2 style={ONBOARDING_STATUS_STYLES.title}>Check Onboarding Status</h2>
                                    <p style={ONBOARDING_STATUS_STYLES.subtitle}>
                                        Review latest onboarding decision, assigned reviewers, notifications, and conversation history.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={ONBOARDING_STATUS_STYLES.headerActions}>
                            <button
                                className="btn btn-sm onb-link-btn"
                                style={ONBOARDING_STATUS_STYLES.refreshButton}
                                onClick={handleRefresh}
                                disabled={isDataFetching}
                                title="Refresh Onboarding Status"
                            >
                                <i className={`fa fa-refresh ${isDataFetching ? "fa-spin" : ""}`} aria-hidden="true"></i>
                                {isDataFetching ? "Fetching..." : "Refresh"}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body border-1" style={ONBOARDING_STATUS_STYLES.cardBody}>
                    {isDataFetching && appTasklist.length > 0 && (
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "8px 18px",
                            background: "#eff6ff",
                            borderTop: "1px solid #bfdbfe",
                            borderBottom: "1px solid #bfdbfe",
                            color: "#1e40af",
                            fontSize: "12px",
                            fontWeight: 600
                        }}>
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                                <i className="fa fa-circle-o-notch fa-spin" style={{ color: "#2563eb", fontSize: "13px" }}></i>
                                <span>Fetching updated onboarding status...</span>
                            </div>
                            <span style={{ fontSize: "11px", color: "#3b82f6", fontWeight: 500 }}>Updating</span>
                        </div>
                    )}
                    <div className="table-responsive" style={ONBOARDING_STATUS_STYLES.tableWrap}>
                        <table
                            className="table align-items-center mb-0 onboarding-status-table"
                            style={{
                                ...ONBOARDING_STATUS_STYLES.table,
                                opacity: isDataFetching && appTasklist.length > 0 ? 0.7 : 1,
                                transition: "opacity 0.2s ease"
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>ID</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Submission Details</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Actions</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Reviewer Assigned</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Reviewer Re-Assigned</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Status</th>
                                    <th style={ONBOARDING_STATUS_STYLES.tableHeadCell}>Communications</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isDataLoading ? (
                                    <tr>
                                        <td colSpan="7" style={{ padding: "40px 20px", textAlign: "center", background: "#ffffff" }}>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>
                                                <div style={{ width: "40px", height: "40px", background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", color: "#000000", fontSize: "16px" }}>
                                                    <i className="fa fa-circle-o-notch fa-spin"></i>
                                                </div>
                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#666666" }}>
                                                    {isDataFetching ? "Fetching onboarding status..." : "Loading onboarding status..."}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : appTasklist.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" style={{ padding: "48px 20px", textAlign: "center", background: "#ffffff" }}>
                                            <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                                                <i className="fa fa-file-text-o" style={{ fontSize: "28px", color: "#94a3b8" }}></i>
                                                <div style={{ fontWeight: 600, color: "#0f172a" }}>No Onboarding Records Found</div>
                                                <div style={{ fontSize: "12px", color: "#64748b" }}>There are no onboarding status records available at this time.</div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    appTasklist.map((item, key) => (
                                        <tr key={item.wiid || key}>
                                            <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                                <div style={ONBOARDING_STATUS_STYLES.idValue}>
                                                    <i className="fa fa-hashtag" style={ONBOARDING_STATUS_STYLES.idIcon} aria-hidden="true"></i>
                                                    {item.ciid}
                                                </div>
                                            </td>
                                            <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                                <div style={ONBOARDING_STATUS_STYLES.dateContainer}>
                                                <div style={ONBOARDING_STATUS_STYLES.datePrimary}>
                                                    <i className="fa fa-calendar" style={{ color: "#000000", fontSize: "11px" }} aria-hidden="true"></i>
                                                    <Moment format="MMM Do, YYYY">
                                                        {item.startDateTime}
                                                    </Moment>
                                                </div>
                                                <div style={ONBOARDING_STATUS_STYLES.dateSecondary}>
                                                    <i className="fa fa-clock-o mr-1" style={{ color: "#94a3b8", fontSize: "11px" }} aria-hidden="true"></i>
                                                    <Moment format="h:mm a">
                                                        {item.startDateTime}
                                                    </Moment>
                                                </div>
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            <div style={ONBOARDING_STATUS_STYLES.actionStack}>
                                                <button
                                                    onClick={() => handleViewAppSummary(item, "view")}
                                                    className="btn btn-sm onb-link-btn"
                                                    style={ONBOARDING_STATUS_STYLES.viewAction}
                                                >
                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                    View Form
                                                </button>
                                                <button
                                                    onClick={() => handleViewAppSummary(item, "edit")}
                                                    className="btn btn-sm onb-link-btn"
                                                    style={ONBOARDING_STATUS_STYLES.editAction}
                                                >
                                                    <i className="fa fa-pencil" aria-hidden="true"></i>
                                                    Edit Details
                                                </button>
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            {item.reassignById > 0 ? <>
                                                {renderReviewerDetails(
                                                    item.reassignByName,
                                                    item.reassignByRole,
                                                    item.reassignByRegistrationType !== "WP" &&
                                                    item.reassignByRegistrationType !== "PP" &&
                                                    item.reassignByRegistrationType,
                                                    item.reassignByEmail,
                                                    item.reassignByContact
                                                )}
                                            </> : <>
                                                {item.performerId !== parseInt(currentUser.id) && <>
                                                    {renderReviewerDetails(
                                                        item.performer,
                                                        item.role,
                                                        `${item.partner || ""} ${item.registrationType !== "WP" &&
                                                            item.registrationType !== "PP" &&
                                                            item.registrationType ? item.registrationType : ""}`.trim(),
                                                        item.email,
                                                        item.contact
                                                    )}
                                                </>}
                                            </>}
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            {item.reassignById > 0 && item.performerId !== parseInt(currentUser.id) && <>
                                                {renderReviewerDetails(
                                                    item.performer,
                                                    item.role,
                                                    `${item.partner || ""} ${item.registrationType !== "WP" &&
                                                        item.registrationType !== "PP" &&
                                                        item.registrationType ? item.registrationType : ""}`.trim(),
                                                    item.email,
                                                    item.contact,
                                                    item.reassignDateTime
                                                )}
                                            </>}
                                        </td>
                                        <td style={{ ...ONBOARDING_STATUS_STYLES.rowCell, whiteSpace: "pre-wrap" }}>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "flex-start" }}>
                                                {item.performerId === parseInt(currentUser.id) ?
                                                    <button
                                                        className="btn btn-sm"
                                                        style={{ ...ONBOARDING_STATUS_STYLES.viewAction, border: "1px solid #3b82f6", color: "#000000", background: "rgba(59, 130, 246, 0.05)", padding: "9px 18px", borderRadius: "0px", textDecoration: "none" }}
                                                        onClick={() => handleCurrentTask(item.wiid)}
                                                    >
                                                        <i className="fa fa-play-circle" aria-hidden="true"></i>
                                                        {item.wfPhase}
                                                    </button> : (
                                                        <span style={getStatusPillStyle(item.wfPhase)}>
                                                            {item.wfPhase === "Approved" ? (
                                                                <i className="fa fa-check-circle" style={{ fontSize: "14px" }} aria-hidden="true"></i>
                                                            ) : item.wfPhase === "Rejected" ? (
                                                                <i className="fa fa-times-circle" style={{ fontSize: "14px" }} aria-hidden="true"></i>
                                                            ) : (
                                                                <i className="fa fa-clock-o" style={{ fontSize: "14px" }} aria-hidden="true"></i>
                                                            )}
                                                            {item.wfPhase}
                                                        </span>
                                                    )}
                                                {usrType !== "candidate" && (
                                                    <div style={{ marginTop: "2px" }}>
                                                        {getPopover(getFieldData(item.stateData, "contractdocuments", "Notification_Notes"))}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td style={ONBOARDING_STATUS_STYLES.rowCell}>
                                            {item.taskDoneStatus !== 0 && item.wfPhase !== "Application" && (
                                                <button
                                                    className="btn btn-sm onb-link-btn"
                                                    style={{ ...ONBOARDING_STATUS_STYLES.viewAction, position: "relative" }}
                                                    onClick={() => handleMsgShowHide(item)}
                                                >
                                                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                                                    View History
                                                    {item.unreadMessage > 0 && (
                                                        <span style={ONBOARDING_STATUS_STYLES.unreadBadge}>
                                                            {item.unreadMessage}
                                                        </span>
                                                    )}
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        {timerShowHide && <TimerPopup
            timerShowHide={timerShowHide}
            handleTimerModalShowHide={handleTimerModalShowHide}
        ></TimerPopup>}
        {msgShowHide &&
            <AppMessages
                msgShowHide={msgShowHide}
                handleMsgShowHide={handleMsgShowHide}
                currentApp={currentApp}
                workflowId={wfId}
            ></AppMessages>}
    </React.Fragment>
}
